import React from 'react';

import useEvent from '@lyearn/core/hooks/useEvent';
import useScreen from '@lyearn/core/hooks/useScreen';
import { PopoverContentPosition } from '@lyearn/ui';
import { Popover } from '@lyearn/ui';
import {
  FilesEntityConfig,
  PROJECTS_WITH_STAGES_QUERY_PARAMS,
} from '@/components/FilterManager/EntityFilter/entity/files';
import FilterBody from '@/components/FilterNew/components/Body';
import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import { NewFilterOption } from '@/components/FilterNew/types';

const LIST_CONFIG: FilterBodyListConfig = {
  ...FilesEntityConfig,
  listVariant: 'single-ungrouped-finite',
};

const EMPTY_ARRAY: any[] = [];

function ProjectSelectMenu({
  currentProjectId,
  children,
  popoverPosition,
  onSelect,
  disabled,
}: {
  currentProjectId?: string;
  children: React.ReactNode;
  popoverPosition?: PopoverContentPosition;
  onSelect: (projectId: string) => void;
  disabled?: boolean;
}) {
  const onChange = useEvent((value: NewFilterOption[]) => {
    const projectId = value[0].value;
    onSelect(projectId);
  });
  const { isMobile } = useScreen();

  return (
    <Popover>
      {({ open, onOpenChange }) => (
        <>
          <Popover.Button disabled={disabled}>{children}</Popover.Button>
          {open ? (
            <Popover.Content
              position={popoverPosition}
              renderAs={isMobile ? 'bottom-sheet' : 'popover'}>
              <FilterBody
                initialSelectedOptions={EMPTY_ARRAY}
                listConfig={LIST_CONFIG}
                queryParams={{
                  ...PROJECTS_WITH_STAGES_QUERY_PARAMS,
                  notFileIds: currentProjectId ? [currentProjectId] : undefined,
                }}
                onChange={onChange}
                onToggle={onOpenChange}
              />
            </Popover.Content>
          ) : null}
        </>
      )}
    </Popover>
  );
}

export default ProjectSelectMenu;
